import { render, staticRenderFns } from "./RulesList.vue?vue&type=template&id=17b64d60&"
import script from "./RulesList.vue?vue&type=script&lang=ts&"
export * from "./RulesList.vue?vue&type=script&lang=ts&"
import style0 from "./RulesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports